// TODO: to be deprecated
export const i18nAlarmPage = {
  sections: {
    prediction_graph: 'Modelo de riesgo de falla',
    pump_curve: 'Curva de performance da bomba',
    sensors_graph: 'Datos del sensor',
    analysis: 'Análisis',
    history: 'Histórico',
    event_list: 'Ultimas eventos {{asset}}',
    flat_line_graph: 'Flat line',
    diagnostic: 'Diagnóstico',
    recommendation: 'Recomendaciones',
  },
  components: {
    alarm_summary: {
      start_time: 'Comienzo',
      end_time: 'Término',
      asset_name: 'Equipo',
      description: 'Descripción de la alarma',
      status: 'Estado',
      classification: 'Clasificación',
      model: 'Modelo',
      id: 'ID de la alarma',
    },
    analysis: {
      fields: {
        status: 'Estado',
        classification: 'Clasificación',
        action: 'Acción del operador',
        work_order: 'Orden de servicio (número)',
        reason: 'Razón',
        failure_occurred: '¿Hubo falla?',
        additional_info: 'Informaciones adicionales',
        end_date: 'Estimación para completar la investigación',
      },
      actions: {
        attach: 'Adjuntar archivo',
        save: 'Guardar',
        attachments: 'Adjuntos',
        required_field: 'Campo obligatorio',
        max_length: 'Longitud máxima de {{size}} caracteres',
      },
    },
    suspension: {
      suspend_new_alarms: 'Suspende nuevas alarmas por un período',
      this_model_no_alarms: 'Este modelo no generará nuevas alarmas hasta la fecha siguientes.',
      select_date: 'Seleccione fecha',
    },
    history: {
      comment_placeholder: 'Añadir comentarios',
      empty_history: 'Alarma sin historial de cambios',
      action_title: {
        attach_file: 'Archivo adjunto',
        remove_file: 'Archivo eliminado',
        status_change: '{{userName}} cambió el estado de la alarma',
        change_end_date: '{{userName}} cambió la fecha de finalización',
        add_work_order: '{{userName}} agregó un número de Orden de Servicio',
        add_details: '{{userName}} ingresó un diagnóstico',
      },
      action: {
        attach_file: '{{userName}} anexou {{filename}}',
        remove_file: '{{userName}} removeu {{filename}}',
        status_change: '{{userName}} cambió el estado de {{previousStatus}} para {{currentStatus}}',
        change_end_date: '{{userName}} cambió la fecha de finalización para {{endDate}}',
        add_work_order: '{{userName}} agregó un número de Orden de Servicio: {{workNumber}}',
        add_details: '{{userName}} ingresó un diagnóstico: {{details}}',
      },
    },
    sensors_graph: {
      variables_contribution: 'Contribución de las variables',
    },
  },
  message: {
    generic_error: {
      title: 'Ops..',
      message: 'Ha ocurrido un error inesperado. Espera unos minutos e inténtalo de nuevo',
    },
    inexistent_alarm: {
      title: 'Alarma no encontrada',
      message: 'Intente con una identificación de alarma válida',
    },
    analysis_submit: {
      success: { title: 'Éxito', message: 'Análisis enviado' },
      error: { title: 'Error', message: 'No se pudo enviar el análisis' },
    },
    features_contribution_error: {
      title: 'Ops..',
      message: 'Error ao cargar datos de contribuición por feature',
    },
  },
};
